module.exports = __webpack_public_path__ + "static/img/etek-jc-m04.fc606be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/etek-jc-m04.png
// module id = +LgX
// module chunks = 1